import { Input } from '@toggle/design-system';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { z } from 'zod';

import * as S from './LinkInput.styles';
import {
  formatWebsiteInfo,
  MAX_CUSTOM_SOURCES,
  WebsiteInfo,
} from './TrustedSourcesModal';

const LINK_SPLIT_REGEX = /[,\s\n]+/;
const urlSchema = z
  .string()
  .transform(url => (/^https?:\/\//i.test(url) ? url : `https://${url}`))
  .pipe(z.url());

interface LinkInputProps {
  sourceCount: number;
  handleAddWebsites: (websites: WebsiteInfo[]) => void;
}

export const LinkInput = ({
  sourceCount,
  handleAddWebsites,
}: LinkInputProps) => {
  const { t } = useTranslation(['chat']);

  const [inputValue, setInputValue] = useState<string>('');

  const addSources = (inputValue: string) => {
    if (sourceCount < MAX_CUSTOM_SOURCES) {
      const parsedLinks = inputValue
        .split(LINK_SPLIT_REGEX)
        .map(link => link.trim())
        .filter(link => link.length > 0 && urlSchema.safeParse(link).success)
        .slice(0, MAX_CUSTOM_SOURCES - sourceCount);

      handleAddWebsites(formatWebsiteInfo(parsedLinks));

      setInputValue('');
    }
  };

  return (
    <S.LinkInputRoot>
      <Input
        label={t('chat:trustedSources.modal.inputLabel')}
        value={inputValue}
        onChange={e => {
          setInputValue(e.target.value);
        }}
        onBlur={() => {
          addSources(inputValue);
        }}
        onKeyUp={e => {
          e.stopPropagation();
        }}
        onKeyDown={e => {
          if (e.key === 'Enter') {
            addSources(inputValue);
          }
        }}
        onPaste={e => {
          addSources(e.clipboardData.getData('text'));
        }}
      />
    </S.LinkInputRoot>
  );
};
